<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <div class="d-flex justify-content-between">
        <h1 class="page-header">
          <a
            href="#"
            @click.prevent="$router.push({ name: 'employee' })"
            class="mr-2"
          >
            <i class="fas fa-arrow-left"></i>
          </a>
          {{ $t('administration.employee.employeeProfile.employeeProfile') }}
        </h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t(
                'administration.employee.employeeProfile.employeeProfile'
              ),
              href: '/employees'
            },
            {
              text: $t('administration.employee.employeeProfile.show'),
              active: true
            }
          ]"
        />
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-5 col-sm-12">
          <ts-card>
            <div id="cover-image">
              <img :src="require('@/assets/cover.png')" alt class="cover" />
              <div id="img-frame" class="text-center mb-1">
                <img :src="photoEmp(model)" @error="onError(model)" />
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12 text-center">
                <span>{{ model.emp_id }}</span>
                <h3
                  class="text-center ts-font-bold ts-text-lg mt-2 mb-0 text-uppercase text-primary"
                >
                  {{ model.name_en }}
                </h3>
                <small class="text-center text-default">
                  {{ model.position ? model.position.pos_name_en : '' }}
                </small>
              </div>
            </div>
            <ts-card-wrapper>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.employeeProfile.nameKh')
                  }}</span>
                  <p class="pull-right kh-font">
                    {{ model.name_kh ? model.name_kh : '-' }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.employeeProfile.nameEn')
                  }}</span>
                  <p class="pull-right">
                    {{ model.name_en ? model.name_en : '-' }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.employeeProfile.gender')
                  }}</span>
                  <p class="pull-right">
                    {{
                      model.gender
                        ? model.gender == 1
                          ? 'Male'
                          : 'Female'
                        : '-'
                    }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.employeeProfile.dateOfBirth')
                  }}</span>
                  <p class="pull-right">
                    {{ model.date_of_birth ? model.date_of_birth : '-' }}
                  </p>
                </li>
                <li class="list-group-item">
                  <span>{{
                    $t('administration.employee.employeeProfile.maritalStatus')
                  }}</span>
                  <p class="pull-right">
                    {{
                      model.marital_status
                        ? model.marital_status == 1
                          ? 'Single'
                          : 'Married'
                        : '-'
                    }}
                  </p>
                </li>
              </ul>
            </ts-card-wrapper>
          </ts-card>
          <br />
          <!-- begin b-card -->
          <b-card no-body>
            <b-card-header
              header-tag="header"
              class="card-header pointer-cursor collapsed"
              aria-expanded="false"
              v-b-toggle.addressContact
            >
              {{ $t('administration.employee.employeeProfile.addressContact') }}
            </b-card-header>
            <b-collapse id="addressContact" visible accordion="my-accordion">
              <b-card-body>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item address">
                    <span class="font-bold"
                      ><i class="fas fa-map-marker-alt m-r-5"></i>
                      {{
                        $t('administration.employee.employeeProfile.address')
                      }}</span
                    >
                    <br />
                    <small>
                      {{
                        model.village
                          ? model.village.village_name
                            ? model.village.village_name + ', '
                            : ''
                          : ''
                      }}
                      {{
                        model.commune
                          ? model.commune.commune_name
                            ? model.commune.commune_name + ', '
                            : ''
                          : ''
                      }}
                      {{
                        model.district
                          ? model.district.district_name
                            ? model.district.district_name + ', '
                            : ''
                          : ''
                      }}
                      {{
                        model.province
                          ? model.province.province_name
                            ? model.province.province_name + '.'
                            : '-'
                          : '-'
                      }}
                    </small>
                    <br />
                    <small class="kh-font">
                      {{
                        model.village
                          ? model.village.village_name_native
                            ? model.village.village_name_native + ', '
                            : ''
                          : ''
                      }}
                      {{
                        model.commune
                          ? model.commune.commune_name_native
                            ? model.commune.commune_name_native + ', '
                            : ''
                          : ''
                      }}
                      {{
                        model.district
                          ? model.district.district_name_native
                            ? model.district.district_name_native + ', '
                            : ''
                          : ''
                      }}
                      {{
                        model.province
                          ? model.province.province_name_native
                            ? model.province.province_name_native + '.'
                            : '-'
                          : '-'
                      }}
                    </small>
                  </li>
                  <li class="list-group-item address mt-2">
                    <span class="font-bold"
                      ><i class="fas fa-phone m-r-5"></i>
                      {{
                        $t('administration.employee.employeeProfile.contact')
                      }}</span
                    >
                    <br />
                    <small>
                      {{ model.phone_number_1 ? model.phone_number_1 : '' }}
                      {{
                        model.phone_number_2 ? ' / ' + model.phone_number_2 : ''
                      }}
                    </small>
                  </li>
                </ul>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!-- end b-card -->
          <!-- begin b-card -->
          <b-card no-body>
            <b-card-header
              header-tag="header"
              class="card-header pointer-cursor collapsed"
              aria-expanded="false"
              v-b-toggle.notification
            >
              {{
                $t(
                  'administration.employee.employeeProfile.notificationReceiver'
                )
              }}
            </b-card-header>
            <b-collapse id="notification" visible accordion="my-accordion">
              <b-card-body>
                <div class="form-group">
                  <div class="checkbox checkbox-css checkbox-inline">
                    <ts-checkbox disabled v-model="model.email_notification">{{
                      $t(
                        'administration.employee.employeeProfile.mobileNotification'
                      )
                    }}</ts-checkbox>
                  </div>
                  <div class="checkbox checkbox-css checkbox-inline">
                    <ts-checkbox disabled v-model="model.mobile_notification">{{
                      $t(
                        'administration.employee.employeeProfile.mobileNotification'
                      )
                    }}</ts-checkbox>
                  </div>
                </div>
                <div class="overflow-auto">
                  <table class="table table-hover ui-table ts-table">
                    <thead>
                      <tr>
                        <th>{{ $t('employee.nameEn') }}</th>
                        <th>{{ $t('employee.nameKh') }}</th>
                        <th class="text-center">Gender</th>
                      </tr>
                    </thead>
                    <tbody v-if="notification_receiver.length > 0">
                      <tr
                        v-for="(record, index) in notification_receiver"
                        :key="index"
                      >
                        <td class="ts-whitespace-no-wrap">
                          {{ record.name_en }}
                        </td>
                        <td class="ts-whitespace-no-wrap">
                          {{ record.name_kh }}
                        </td>
                        <td class="text-center ts-whitespace-no-wrap">
                          <span v-if="record.gender == 1">{{
                            $t('employee.male')
                          }}</span>
                          <span v-else>{{ $t('employee.female') }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td
                          class="ts-whitespace-no-wrap text-center"
                          colspan="3"
                        >
                          {{ $t('employee.noRecord') }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!-- end b-card -->
        </div>
        <div class="col-lg-9 col-md-7 col-sm-12">
          <ts-card>
            <ts-card-wrapper>
              <form>
                <h1 class="section-divider">
                  {{ $t('administration.employee.employeeProfile.employment') }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.hiringDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{ model.hired_date }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.employeeID'
                          )
                        }}</label
                      >
                      <div class="col-md-7">
                        {{ model.emp_id }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.division')
                        }}</label
                      >
                      <div class="col-md-7">
                        {{
                          model.division ? model.division.division_name_en : ''
                        }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.department'
                          )
                        }}</label
                      >
                      <div class="col-md-7">
                        {{
                          model.department
                            ? model.department.department_name_en
                            : ''
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.position')
                        }}</label
                      >
                      <div class="col-md-7">
                        {{ model.position ? model.position.pos_name_en : '' }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.status')
                        }}
                      </label>
                      <div class="col-md-7">
                        <span
                          class="badge badge-success"
                          v-if="model.status == 'Active'"
                          >{{ $t('employee.active') }}</span
                        >
                        <span
                          class="badge badge-danger"
                          v-if="model.status == 'Resigned'"
                          >{{ $t('employee.resigned') }}</span
                        >
                        <span
                          class="badge badge-warning"
                          v-if="model.status == 'Terminated'"
                          >{{ $t('employee.terminated') }}</span
                        >
                        <span
                          class="badge badge-info"
                          v-if="model.status == 'Suspend'"
                          >{{ $t('employee.suspend') }}</span
                        >
                        <span
                          class="badge badge-secondary"
                          v-if="model.status == 'Cancelled'"
                          >{{ $t('employee.cancelled') }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.statusEffectiveDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.status_effective_date
                            ? model.status_effective_date
                            : '-'
                        }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.shift')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.shift
                            ? model.shift.shift_name +
                              ' (' +
                              model.shift.shift_type +
                              ')'
                            : ''
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{
                    $t('administration.employee.employeeProfile.addressContact')
                  }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.province')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.province
                            ? model.province.province_name
                              ? model.province.province_name
                              : '-'
                            : '-'
                        }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.district')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.district
                            ? model.district.district_name
                              ? model.district.district_name
                              : '-'
                            : '-'
                        }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.commune')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.commune
                            ? model.commune.commune_name
                              ? model.commune.commune_name
                              : '-'
                            : '-'
                        }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.village')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.village
                            ? model.village.village_name
                              ? model.village.village_name
                              : '-'
                            : '-'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.phoneLine1'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{ model.phone_number_1 }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.phoneLine2'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{ model.phone_number_2 ? model.phone_number_2 : '-' }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.email')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{ model.email ? model.email : '-' }}
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{ $t('administration.employee.employeeProfile.idCard') }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.idType')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.type
                            ? model.type.id_type_name
                              ? model.type.id_type_name
                              : '-'
                            : '-'
                        }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.idNumber')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{ model.id_number ? model.id_number : '-' }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.expiryDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{ model.id_expiry_date ? model.id_expiry_date : '-' }}
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{
                    $t('administration.employee.employeeProfile.drivingLicense')
                  }}
                </h1>
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.drivingLicenseNo'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.driving_license_no
                            ? model.driving_license_no
                            : '-'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.drivingIssueDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.driving_issue_date
                            ? model.driving_issue_date
                            : '-'
                        }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.drivingExpiringDate'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.driving_expiry_date
                            ? model.driving_expiry_date
                            : '-'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <h1 class="section-divider">
                  {{ $t('administration.employee.employeeProfile.family') }}
                </h1>
                <div class="row mb-4">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.spouseName'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{ model.spouse_name ? model.spouse_name : '-' }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t(
                            'administration.employee.employeeProfile.spouseOccupation'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.spouse_occupation
                            ? model.spouse_occupation.occupation_name
                              ? model.spouse_occupation.occupation_name
                              : '-'
                            : '-'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label text-right"
                      >
                        {{
                          $t('administration.employee.employeeProfile.children')
                        }}
                      </label>
                      <div class="col-md-7">
                        {{
                          model.number_of_children
                            ? model.number_of_children
                            : '-'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'employee-show',
  data() {
    return {
      model: {
        emp_id: '',
        name_kh: '',
        name_en: '',
        position_id: '',
        hired_date: '',
        gender: '',
        date_of_birth: '',
        marital_status: '',
        id_type: '',
        id_number: '',
        id_expiry_date: '',
        phone_number_1: '',
        phone_number_2: '',
        email: '',
        driving_license_no: '',
        driving_issue_date: '',
        driving_expiry_date: '',
        status: 'Active',
        status_effective_date: '',
        province_code: '',
        district_code: '',
        commune_code: '',
        village_code: '',
        spouse_name: '',
        spouse_occupation_id: '',
        number_of_children: '',
        division_id: '',
        department_id: '',
        shift_id: '',
        notification_receiver: [],
        mobile_notification: false,
        email_notification: false,
        photo: null
      },
      loadingPreData: false,
      notification_receiver: [],
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      file: require('../../assets/user_default.png')
    }
  },
  async created() {
    this.loadingPreData = true
    await Promise.all([this.fetchEmployees()]).then(responses => {
      this.loadingPreData = false
      this.setData()
    })
  },
  computed: {
    ...mapState('employee', ['found_data', 'employees'])
  },
  methods: {
    ...mapActions('employee', ['fetchEmployees']),
    setData() {
      if (this.found_data === null) return

      this.model = Object.assign({}, this.found_data)
      this.getReceiverList(this.found_data)
    },
    defaultUser(e) {
      e.target.src = this.file
    },
    photoEmp(record) {
      if (record.photo) {
        return record.photo
      }
      return record.gender == 1 ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event.target.src = record.gender == 1 ? this.manPhoto : this.womenPhoto
    },
    getReceiverList(value) {
      this.notification_receiver = []
      if (!value.notification_receiver) {
        return []
      }
      let empId = value.notification_receiver.split(',')
      empId.map(el => {
        let employee = this.employees.filter(em => em.staff_id == el)
        this.notification_receiver.push({
          name_kh: employee[0].name_kh,
          name_en: employee[0].name_en,
          gender: employee[0].gender
        })
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('employee/RESET_STATE')
      this.$store.commit('employee/SET_FOUND_DATA', {})
    }
    next()
  }
}
</script>
<style scoped>
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.list-group-item {
  border: none !important;
  padding: 15px 0 15px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -19%;
}
#img-frame img {
  object-fit: contain;
  width: 25%;
  height: 25%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
